"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Create = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Create_1 = require("@reactionable/core/lib/crud/create/Create");
function Create(props) {
    return jsx_runtime_1.jsx(Create_1.Create, Object.assign({}, props), void 0);
}
exports.Create = Create;
//# sourceMappingURL=Create.js.map